import styled, { css } from 'styled-components'
import {
  space,
  SpaceProps,
  typography,
  TypographyProps,
  color,
  ColorProps,
} from 'styled-system'
import { UIColorTheme } from 'global'

interface IHeadingProps
  extends SpaceProps,
    TypographyProps,
    ColorProps,
    UIColorTheme {
  handwritten?: boolean
}

export const Heading = styled.h1<IHeadingProps>`
  letter-spacing: 0;
  ${space}
  ${typography}
  ${color}
  ${({ uiColorTheme }) =>
    css`
      color: ${uiColorTheme === 'light' ? '#fff' : '#000'};
    `}
`
